import { useEffect, useState } from 'react';

/** True once `flag` has stayed true for `delayMs`; false as soon as it turns false. */
export function useDelayedFlag(flag: boolean, delayMs: number): boolean {
  const [delayed, setDelayed] = useState(flag);
  useEffect(() => {
    if (!flag) {
      setDelayed(false);
      return;
    }
    if (delayMs <= 0) {
      setDelayed(true);
      return;
    }
    const timer = setTimeout(() => setDelayed(true), delayMs);
    return () => clearTimeout(timer);
  }, [flag, delayMs]);
  return flag && delayed;
}
